import { colors, spacing } from '@akin-home/theme';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome';
import React from 'react';
import { StyleSheet, Text, TextStyle, View } from 'react-native';

export type RobotSettingsHeaderProps = {
  icon?: IconProp;
  iconSize?: number;
  text?: string;
  textStyle?: TextStyle;
  disabled?: boolean;
};

export const RobotSettingsHeader = (props: RobotSettingsHeaderProps) => {
  const { disabled = false } = props;

  return (
    <View style={styles.titleContainer}>
      {props.icon ? (
        <FontAwesomeIcon
          icon={props.icon}
          size={props.iconSize ?? 25}
          color={disabled ? colors.grey.dim : undefined}
        />
      ) : null}
      {props.text ? (
        <Text
          style={[
            styles.text,
            props.textStyle,
            disabled && { color: colors.grey.dim },
          ]}
        >
          {props.text}
        </Text>
      ) : null}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    gap: spacing[2],
  },
  titleContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: spacing[1],
  },
  text: {
    fontSize: 16,
  },
});
